// eslint-disable-next-line import/prefer-default-export
export enum AlenFirmwareUpdateStatus {
  NoUpdate = 0,
  UpdateAvailable = 1,
  UpdateInProgress = 2,
  UpdateCompleted = 3,
  UpdateError = 4,
  UpdateTimeout = 7,
}
